import { Stack as i, IconButton as r } from "@mui/material";
import { KeyboardDoubleArrowLeftRounded as e } from "@mui/icons-material";
import { styled as t } from "./styled2.mjs";
import { StennLogo as a } from "./index43.mjs";
const g = t(i)`
	position: relative;
	z-index: ${({ theme: o }) => o.zIndex.mobileStepper};
	height: 45px;
`;
t(r)`
	padding: ${({ theme: o }) => o.spacing(0.5)};
	opacity: ${({ $status: o }) => o === "entered" || o === "entering" ? 1 : 0};
	transform: ${({ $canCollapse: o }) => o ? "rotate(180deg)" : void 0};
`;
t(e)`
	color: ${({ theme: o }) => o.palette.common.darkGrey};
	font-size: 20px;
`;
const l = t(a)`
	position: absolute;
	left: ${({ compact: o }) => o ? "5px" : 0};
	top: 0;
	opacity: ${({ $isVisible: o }) => o ? 1 : 0};
	transition: ${({ theme: o, $isVisible: n }) => o.transitions.create("opacity", {
  easing: o.transitions.easing.sharp,
  duration: n ? o.transitions.duration.enteringScreen : o.transitions.duration.leavingScreen
})};
`;
export {
  l as Logo,
  g as StackHeader
};
//# sourceMappingURL=styles120.mjs.map
